import { RiskProductKeyMetric } from '../services/dtos/riskProducts/creditRiskLevels.dto';

export enum Chart {
  Cqs = 'CQS',
  Cre = 'CRE',
}

export interface RiskProductsData {
  cs_companyid: number;
  rid: number;
  ticker: string;
  model_id: string;
  region_id: string;
  data: HistoricalRecord[];
}

export interface HistoricalRecord {
  rid: number;
  calculation_date: string;
  cqs: number | null;
  fs: number | null;
  acr_level_4: string | null;
  acr: string | null;
  acs: number | null;
  comulative_default_probalitity_1y: number | null;
  credit_risk_level: string | null;
  credit_risk_level_num: number | null;
}

export enum COMPANY_MODEL {
  AEROSPACE = 'Aerospace / Defense',
  AIRLINES = 'Airlines',
  AUTOMOTIVE = 'Automotive',
  CAPITAL_GOODS = 'Capital Goods',
  CHEMICALS = 'Chemicals',
  CONSTRUCTION_AGGREGATES = 'Construction Aggregates',
  CONSUMER = 'Consumer Products and Services',
  DIVERSIFIED_CONGLOMERATES = 'Diversified Conglomerates',
  FOOD_BEVERAGES = 'Food & Beverages',
  GAMING_LEISURE = 'Gaming / Leisure',
  HEALTHCARE_PHARMACEUTICALS = 'Healthcare / Pharmaceuticals',
  HOMEBUILDING = 'Homebuilding',
  MEDIA_CABLE = 'Media and Cable',
  METAL_MINING = 'Metal and Mining',
  OIL_AND_GAS = 'Oil and Gas',
  PAPER_PACKAGING = 'Paper and Packaging',
  PIPELINES_MLP = 'Pipelines and MLP',
  RETAIL_GROCERS = 'Retail / Grocers',
  SHIPPING_INFRASTRUCTURE = 'Shipping and Infrastructure',
  TECHNOLOGY = 'Technology',
  TELECOMM = 'Telecommunications',
  TRUCKING_RAILS = 'Trucking and Rails',
  TMT = 'TMT',
  UTILITIES = 'IPP and Utilities',
  FINANCE = 'Finance',
  BANKS = 'Banks',
  INSURANCE = 'Insurance',
  LHINSURANCE = 'L&H Insurance',
  PCINSURANCE = 'P&C Insurance',
  REITS = 'REITs',
}

export enum CREDIT_RISK_LEVEL {
  LOW = 'Low',
  MODERATE = 'Moderate',
  HIGH = 'High',
  VERY_HIGH = 'Very High',
}

export interface RiskMetrics {
  cqsMetrics: CqsMetric[];
  creMetrics: CreMetric[];
  modelId: string;
  regionId: string;
}

export interface CreMetric {
  crePercentage: number;
  creditRiskLevel: string;
  calculationDate: string;
}

export interface CqsMetric {
  cqs: number | null;
  acr: string | null;
  acrUngrouped?: string;
  calculationDate: string;
}

export interface RiskOverviewMetrics {
  cqs: {
    cqs: number | null;
    country_risk_level: string;
    credit_quality_difference: string | null;
    country_risk_score: number | null;
    credit_risk_level: string | null;
    cqs_trend_1y: string;
    cqs_trend_3y: string;
    cqs_volatility: string;
    cqs_outlook: string | null;
    canAccess: boolean;
  };
  fas: {
    fallen_angel_score: string;
    canAccess: boolean;
  };
  acr: {
    acr: string;
    acr_previous: string;
    canAccess: boolean;
  };
  cre: {
    cre_1y: number | null;
    cre_3y: number | null;
    cre_5y: number | null;
    cre_trend_1y: string | null;
    cre_trend_6m: string | null;
    canAccess: boolean;
  };
  fscore: {
    canAccess: boolean;
    fscore: number | null;
  };
  cs_analyst_recommendation: string;
  calc_date: string;
  fund_date: string;
  data_date: string;
  model_sector: string;
  notes: string;
}

export interface FundamentalsMetrics {
  display_attributes: FundamentalsAttr[];
  currency: string;
  fund_date: string;
  cs_companyid: number;
}

export interface FundamentalsAttr {
  label: string;
  value: number | null;
  group: string;
}

export interface AccordionItem {
  label: string;
  value: string | number | null;
  tooltip?: string;
  infoContent?: string;
  canAccess?: boolean;
}

export interface AccordionWidgetData {
  item: AccordionItem;
  children: AccordionItem[];
}

export interface CreditRiskLevel {
  companyIds: string[];
  key: RiskProductKeyMetric;
}
